import {

  GET_VECTORS_FAIL,
  GET_VECTORS_SUCCESS,
 
  GET_VECTOR_DETAIL_SUCCESS,
  GET_VECTOR_DETAIL_FAIL,

  GET_AUTH_USER_SUCCESS,
  GET_AUTH_USER_FAIL,
  DELETE_VECTOR_SUCCESS

} from "./actionTypes"

const INIT_STATE = {
  vectors: [],

  vector: {},
}

const Vectors = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_VECTORS_SUCCESS:
      return {
        ...state,
        vectors: action.payload,
      }

    case GET_VECTORS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    
    case GET_VECTOR_DETAIL_SUCCESS:
      return {
        ...state,
        vector: action.payload,
      }

    case GET_VECTOR_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_VECTOR_SUCCESS: 
      return {
        ...state,
        vectors: state.vectors.docs.filter(
          vector => vector._id !== action.payload.id
        ),
      }

    default:
      return state
  }
}

export default Vectors
